import React from 'react'
import i18n from '~/i18n'

import Callout from '~/Common-Objects/Callout'
import ButtonNew from '~/Common-Objects/UI/Button'
import Icon from '~/Common-Objects/UI/Icon'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'

import PosterSmall from '~/assets/images/setup/video-poster-small.png'

const CustomerSuccessCallout = ({ onPosterClick, onClose }) => {
    return (
        <Callout.Wrapper onClose={onClose}>
            <Callout.Splash>
                <img
                    src={PosterSmall}
                    alt='Video Demonstration of Transpond'
                    onClick={onPosterClick}
                    data-ph='customer-success-open-video-modal'
                />
            </Callout.Splash>
            <Callout.Content>
                <SquareChip className='square-chip-purple'>
                    {i18n.t('setup:callout.customer-success.tag')}
                </SquareChip>
                <div>
                    <h4>{i18n.t('setup:callout.customer-success.title')}</h4>
                    <p>{i18n.t('setup:callout.customer-success.body')}</p>
                </div>
                <ButtonNew
                    variant='darkGhost'
                    size='s'
                    iconRight={<Icon name='arrow-right' />}
                    href='https://calendly.com/d/cwdb-gsf-gz8/transpond-overview'
                    target='_blank'
                    postHogTag='customer-success-schedule-tour'
                >
                    {i18n.t('setup:callout.customer-success.button-text')}
                </ButtonNew>
            </Callout.Content>
        </Callout.Wrapper>
    )
}

export default CustomerSuccessCallout
